import { getSessionAuthentication, rms2BasePath } from '../common/Api';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T | null> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface MainGroup {
    id: number;
    mainGroupCode: string;
    mainGroupDescription: string;
}

export interface Department {
    id: number;
    departmentCode: string;
    departmentDescription: string;
    mainGroups: MainGroup[];
}

export async function getDepartment(id: number): Promise<Department> {
    const result = await rms2Fetch<Department>(`departments/${id}`);
    if (!result) throw new Error('Empty response for getDepartment');
    return result;
}

export async function saveDepartment(d: Department): Promise<Department> {
    const result = await rms2Fetch<Department>('departments/save', {
        method: 'POST',
        body: JSON.stringify({
            id: d.id,
            departmentCode: d.departmentCode,
            departmentDescription: d.departmentDescription,
            mainGroupIds: d.mainGroups.map((mg) => mg.id)
        })
    });
    if (!result) throw new Error('Empty response for saveDepartment');
    return result;
}

export async function getMainGroups(): Promise<MainGroup[]> {
    const response = await rms2Fetch<{ mainGroups: MainGroup[] }>('departments/maingroups');
    return response?.mainGroups ?? [];
}
